import ProfileEdit from '../components/publication/ProfileEdit.tsx';

type Props = {};

export default function ProfileCreatePage({}: Props) {
    return (
        <>
            <ProfileEdit />
        </>
    );
}
